<div class="card-body">
    <div id="apex-radar-multiple-series"></div>
</div>